import React from "react";
import { cn } from "@/utils/utils";

interface DashedBorderProps extends React.HTMLAttributes<HTMLDivElement> {
  dashLength?: number;
  gapLength?: number;
  strokeWidth?: number;
  borderRadius?: number;
  /**
   * Round caps extend every dash by half the stroke width at each end, so they
   * lengthen the dash and shorten the gap relative to the numbers passed in.
   * Pass "butt" where the dash and gap must render at exactly those lengths.
   */
  strokeLinecap?: "butt" | "round";
}

const DashedBorder: React.FC<DashedBorderProps> = ({
  className,
  children,
  dashLength = 5,
  gapLength = 7,
  strokeWidth = 2,
  borderRadius = 16,
  strokeLinecap = "round",
  ...props
}) => {
  return (
    <div className={cn("relative", className)} {...props}>
      <svg
        className="absolute inset-0 w-full h-full pointer-events-none"
        preserveAspectRatio="none"
      >
        <rect
          x={strokeWidth / 2}
          y={strokeWidth / 2}
          width={`calc(100% - ${strokeWidth}px)`}
          height={`calc(100% - ${strokeWidth}px)`}
          rx={borderRadius}
          ry={borderRadius}
          fill="none"
          className="stroke-border-border2"
          strokeWidth={strokeWidth}
          strokeDasharray={`${dashLength} ${gapLength}`}
          strokeLinecap={strokeLinecap}
        />
      </svg>
      {children}
    </div>
  );
};

export { DashedBorder };
